// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem","input":"AutoComplete_input__1I6xX"};